import React, { useState } from 'react';
import { SubscriptionRewardModal } from '../SubscriptionRewardModal';
import RewardProgressBar from './RewardProgressBar';
import RewardSubscriptionTotal from './RewardSubscriptionTotal';
import { RewardProgressBarContainer } from './CircularProgressBar.styled';
import { RewardProgressBarProps } from './types';
import SubscriptionRewardMobile from './SubscriptionRewardMobile';
import { application } from '../Utils/application';
import { calculateMonthCompletionValues } from './logic/calculateMonthCompletionValues';

const SubscriptionReward = (props: RewardProgressBarProps) => {
    const { title, subscriptionData, translationConfig, learnMoreConfig, storeConfig, currencyFormat } = props;
    let value = 2;
    let maxAmount = storeConfig?.tiers?.[0]?.max_spend ?? 0;
    let minAmount = storeConfig?.tiers?.[0]?.min_spend ?? 0;
    const maxMonths = storeConfig?.tiers?.[0]?.consecutive_months ?? 0;
    const [show, setShow] = useState(false);
    const handleOpen = () => setShow(true);
    const handleClose = () => setShow(false);
    const rewardData = subscriptionData;
    let minVoucher = 0;
    let maxVoucher = 0;
    const monthCompletionValue = 0;

    storeConfig?.tiers?.map((tier) => {
        if (tier.min_spend < minAmount) {
            minAmount = tier.min_spend;
        }
        // Check if 'max_spend' exists before trying to access it
        if ('max_spend' in tier && tier.max_spend > maxAmount) {
            maxAmount = tier.max_spend;
        }
    });

    storeConfig?.tiers?.map((tier) => {
        if (tier.min_spend === minAmount) {
            let promocode = tier.promo_code;
            promocode = promocode?.split('-')?.[0]?.replace('NSR', '');
            minVoucher = parseInt(promocode);
        }
        if (tier.min_spend === maxAmount) {
            let promocode = tier.promo_code;
            promocode = promocode?.split('-')?.[0]?.replace('NSR', '');
            maxVoucher = parseInt(promocode);
        }
    });
    let voucherValue = 0;
    const amountShow = parseInt(rewardData?.approximateMonthlyTotalResponse?.currentMonthTotal ?? '0');
    if (amountShow < minAmount) {
        voucherValue = minVoucher;
    } else if (amountShow < maxAmount) {
        voucherValue = minVoucher;
    } else if (amountShow > maxAmount) {
        voucherValue = maxVoucher;
    } else {
        voucherValue = 0;
    }
    const notQualifyForRewardThisMonth = amountShow < minAmount && voucherValue !== 0 && value !== maxMonths;

    // Calculate monthCompletionValue and voucherValue
    const { monthCompletionValue: calculatedMonthCompletionValue, voucherValue: calculatedVoucherValue } =
        calculateMonthCompletionValues(
            rewardData,
            minAmount,
            maxAmount,
            minVoucher,
            maxVoucher,
            voucherValue,
            monthCompletionValue,
            maxMonths,
            new Date(),
        );

    // Use the calculated values
    value = calculatedMonthCompletionValue; // or however you want to use it
    voucherValue = calculatedVoucherValue;
    return (
        <RewardProgressBarContainer>
            {application.isMobile ? (
                <SubscriptionRewardMobile
                    value={value}
                    title={title}
                    voucherValue={voucherValue}
                    maxMonths={maxMonths}
                    handleOpenSubscriptionRewardPopup={handleOpen}
                    storeConfig={storeConfig}
                    amountShow={amountShow}
                    notQualifyForRewardThisMonth={notQualifyForRewardThisMonth}
                    translationConfig={translationConfig}
                    learnMoreConfig={learnMoreConfig}
                    currencyAbbreviate={storeConfig?.currencyAbbreviate}
                    currencyFormat={currencyFormat}
                />
            ) : (
                <>
                    <RewardProgressBar
                        value={value}
                        title={title}
                        notQualifyForRewardThisMonth={notQualifyForRewardThisMonth}
                        monthCompletionValue={monthCompletionValue}
                        storeConfig={storeConfig}
                        maxMonths={maxMonths}
                        voucherValue={voucherValue}
                        handleOpenSubscriptionRewardPopup={handleOpen}
                        translationConfig={translationConfig}
                        learnMoreConfig={learnMoreConfig}
                        currencyAbbreviate={storeConfig?.currencyAbbreviate}
                        currencyFormat={currencyFormat}
                    />
                    <RewardSubscriptionTotal
                        notQualifyForRewardThisMonth={notQualifyForRewardThisMonth}
                        value={value}
                        voucherValue={voucherValue}
                        maxMonths={maxMonths}
                        title={title}
                        monthCompletionValue={monthCompletionValue}
                        storeConfig={storeConfig}
                        translationConfig={translationConfig}
                        learnMoreConfig={learnMoreConfig}
                        handleOpenSubscriptionRewardPopup={handleOpen}
                        amountShow={amountShow}
                        currencyAbbreviate={storeConfig?.currencyAbbreviate}
                        currencyFormat={currencyFormat}
                    />
                </>
            )}
            <SubscriptionRewardModal
                show={show}
                close={handleClose}
                amountShow={amountShow}
                learnMoreConfig={learnMoreConfig}
                translationConfig={translationConfig}
            />
        </RewardProgressBarContainer>
    );
};

export default SubscriptionReward;
export { SubscriptionReward };
